import React from 'react'

const IorCostCard = ({
    formData,
    estimateSummary,
    totalItemsValue,
    airfreight,
    insurance,
    cif,
    duty,
    collectionValue,
    hasEstimated
}) => {
    const userCurrency = formData.itemsCurrency || formData.currency || "USD";

    // Only show data if estimation has been run
    if (!hasEstimated) {
        return (
            <div className="w-full h-full flex flex-col items-center justify-center gap-4 p-8">
                <p className="text-gray-500 text-center">
                    Click "Get Quotation" to see cost breakdown
                </p>
            </div>
        );
    }

    // Get services and taxes from the comprehensive estimate summary
    const serviceData = estimateSummary?.services?.map(service => ({
        name: service.description,
        value: service.value,
    })) || [];

    const dhlTaxes = estimateSummary?.dhlTaxes?.map(tax => ({
        name: tax.name,
        value: tax.value,
    })) || [];

    // Combine all data sources - only show service and tax data
    const data = [
        ...serviceData.filter(item => item.value > 0),
        ...dhlTaxes.filter(item => item.value > 0)
    ];

    const totalCost = estimateSummary?.total || 0;

    /**
     * Helper function to format the currency value with the correct
     * currency symbol based on the userCurrency code.
     */
    const formatCurrency = (value) => {
        try {
            return new Intl.NumberFormat('en', { // Using 'en' locale for broad compatibility
                style: 'currency',
                currency: userCurrency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        } catch (e) {
            // Fallback in case of an invalid currency code
            console.error("Currency formatting error:", e);
            return `${userCurrency} ${value.toFixed(2)}`;
        }
    };

    return (
        <div className="w-full h-full flex flex-col items-start justify-center gap-4 rounded-xl">
            <div className="flex flex-grow flex-col w-full gap-4">
                {data.map((item, idx) => (
                    /* * FIXED: 
                     * 1. Changed py-2 to py-4 to restore row height.
                     * 2. Removed the flex-col and &nbsp; p-tag to
                     * fix vertical centering.
                     */
                    <div key={idx} className="w-full flex items-center justify-between border rounded-xl shadow-md hover:shadow-xl transition-all duration-300 ease-in-out px-4 py-4">
                        <div className="flex items-center gap-2 w-full">
                            <div className={`w-3 h-3 rounded-full custom-blink bg-blue`} />
                            {/* REMOVED the flex-col wrapper from here */}
                            <p>{item.name}</p>
                            {/* REMOVED the &nbsp; p-tag */}
                        </div>
                        { /* Kept flex-shrink-0 to fix large value bugs */}

                        {/* * FIXED: Added a fixed width (w-36). This creates a column.
                          * Text defaults to left-aligned, so '$22,000' and '$20'
                          * will now align from the left, as you requested.
                          * You can adjust 'w-36' (144px) if you need more space.
                          */}
                        <p className="font-semibold flex-shrink-0 ml-2 w-24">{formatCurrency(item.value)}</p>
                    </div>
                ))}
            </div>
            <div className="bg-gray-50 rounded-lg border-2 border-dashed flex items-center justify-between p-2 text-sm text-gray-500 w-full">
                <p>
                    {formData.selectedService} • Currency: {userCurrency}
                </p>

                {/* * FIXED: Applied the same fixed width here for
                  * consistent left-alignment with the rows above.
                  */}
                <p className="font-semibold text-black flex-shrink-0 ml-2 w-24">{formatCurrency(totalCost)}</p>
            </div>
        </div>
    );
};

export default IorCostCard;